import { createSlice } from '@reduxjs/toolkit'
import { NameDto } from 'api/Common/Types'
import { WorldCheckTypesDto } from 'api/WorldCheck/Types/WorldCheckTypesDto'

const initialState: ComplianceState = {
  mrlo: [],
  internalRiskLevel: [],
  worldCheckTypes: {
    reasons: [],
    risks: [],
    recordStatuses: [],
    screeningStatuses: [],
  },
}

export interface ComplianceState {
  mrlo: NameDto[]
  internalRiskLevel: NameDto[]
  worldCheckTypes: WorldCheckTypesDto
}

export const complianceSlice = createSlice({
  name: 'compliance',
  initialState,
  reducers: {
    getCountryComplianceMRLOAnalyses: (state, action) => {
      state.mrlo = action.payload
    },
    getCountryComplianceInternalRiskLevel: (state, action) => {
      state.internalRiskLevel = action.payload
    },
    getComplianceWorldCheckTypes: (state, action) => {
      state.worldCheckTypes = action.payload
    },
  },
})
